
import { defineComponent } from 'vue'

export default defineComponent({
    name: "CloseBtn",

    props:[
        "glassTile"
    ]
});
